import { render, staticRenderFns } from "./Modulos.vue?vue&type=template&id=4e4ef24e&"
import script from "./Modulos.vue?vue&type=script&lang=ts&"
export * from "./Modulos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports